module.exports = __webpack_public_path__ + "static/img/icon_game_3.8566d1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_3.png
// module id = zd8n
// module chunks = 0